import { GraphQLFetchPolicy } from '@getaccept/lib-shared/src/graphql/graphql-fetch-policy';
import type { Directory } from '@getaccept/lib-shared/src/types/directory';
import { apolloClientInternal } from '@getaccept/lib-shared/src/internal/apollo-client-internal';
import type { CreateDirectoryDTO } from '../dtos/create-directory-dto';
import type { UpdateDirectoryDTO } from '../dtos/update-directory-dto';
import { DirectoryQueries } from '../graphql/directory.queries';
import { DirectoryMutations } from '../graphql/directory.mutations';

export class DirectoryService {
  static async loadDirectories(directory: string): Promise<Directory[]> {
    const {
      data: { resourceDirectories },
    } = await apolloClientInternal.query({
      query: DirectoryQueries.resourceDirectoriesQuery,
      variables: {
        directory,
      },
      fetchPolicy: GraphQLFetchPolicy.NetworkOnly,
    });
    return resourceDirectories;
  }

  static async create(payload: CreateDirectoryDTO): Promise<Directory> {
    const {
      data: { createResourceDirectory },
    } = await apolloClientInternal.mutate({
      mutation: DirectoryMutations.createDirectoryMutation,
      variables: { payload },
    });
    return createResourceDirectory;
  }

  static async update(payload: UpdateDirectoryDTO): Promise<Directory> {
    const {
      data: { updateResourceDirectory },
    } = await apolloClientInternal.mutate({
      mutation: DirectoryMutations.updateDirectoryMutation,
      variables: { payload },
    });
    return updateResourceDirectory;
  }

  static async delete(id: string): Promise<Directory> {
    const {
      data: { deleteResourceDirectory },
    } = await apolloClientInternal.mutate({
      mutation: DirectoryMutations.deleteDirectoryMutation,
      variables: { id },
    });
    return deleteResourceDirectory;
  }
}
